import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import Login from "../pages/Login";
import ProtectedRoute from "./ProtectedRoute";
import UtilComponent from "./UtilComponent";
import checkIfAppReady from "../helpers/checkIfAppReady";
import LoadingFullPage from "../components/common/Loading/LoadingFullPage";
import DashBoardRoutes from "./DashBoardRoutes";
import ExpiredSubscription from "../pages/ExpiredSubscription";
import ForgotPassword from "../pages/ForgotPassword";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import RefundPolicy from "../pages/RefundPolicy";
import ContactUs from "../pages/ContactUs";
import { updateNetworkStatus } from "../redux/action/networkStatusAction";
import { getOfflineUser } from "../redux/action/offlineDataActions";
import getoffiledata from "../helpers/readOfflineData";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const HomeRoutes = () => {
  const ready = checkIfAppReady();

  const dispatch = useDispatch();
  const {isOnline, isAppOffline} = useSelector((state) => state.networkStatus);

  React.useEffect(() => {
    const handleOnline = () => {
      dispatch(updateNetworkStatus(true));
    };

    const initializeOfflineData = async () => {
      if(window?.api?.isElectron && (isAppOffline || !isOnline)){
        dispatch(getOfflineUser(await getoffiledata("user")))
      }
    };
    initializeOfflineData();

    const handleOffline = () => {
      dispatch(updateNetworkStatus(false));
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [dispatch]);

  return ready ? (
    <React.Fragment>
      <UtilComponent />
      <ScrollToTop />
      <Routes>
        <Route path="/expired" element={<ExpiredSubscription />} />
        
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />

        {/* Dashboard Routes handles its own sub-routes */}
        <Route path="/*" element={<ProtectedRoute component={DashBoardRoutes} />} />
      </Routes>
    </React.Fragment>
  ) : (
    <LoadingFullPage />
  );
};
export default HomeRoutes;
